import { render, staticRenderFns } from "./SalesGeneral.vue?vue&type=template&id=343d99b0&"
import script from "./SalesGeneral.vue?vue&type=script&lang=js&"
export * from "./SalesGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports